export const TABLET_SCREEN_MIN_WIDTH = 600;
export const DESKTOP_SCREEN_MIN_WIDTH = 960;